module.exports = __webpack_public_path__ + "static/media/img2-3.eeac6826.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/diff/img2-3.png
// module id = 1272
// module chunks = 3